import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_create_stock_take: { message: "idle" },
};

export const tenant_create_stock_take_Slice = createSlice({
 name: "tenant_create_stock_take",
 initialState,
 reducers: {
  success_tenant_create_stock_take: (state, action) => {
   state.tenant_create_stock_take = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_create_stock_take: (state, action) => {
   state.tenant_create_stock_take = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_create_stock_take: (state) => {
   state.tenant_create_stock_take = { status: app_consts.IDLE };
  },
  loading_tenant_create_stock_take: (state) => {
   state.tenant_create_stock_take = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_create_stock_take, fail_tenant_create_stock_take, reset_tenant_create_stock_take, loading_tenant_create_stock_take } = tenant_create_stock_take_Slice.actions;

export default tenant_create_stock_take_Slice.reducer;